import { __decorate, __metadata } from "tslib";
import { JsonObject, JsonProperty } from "json2typescript";
import { Timestamp } from "../timestamp.model";
import { ProcessingRun } from "./processing-run.model";
let ProcessingEvent = class ProcessingEvent {
    constructor() {
        this.code = null;
        this.timestamp = null;
        this.run = null;
    }
    static equals(a, b) {
        if (null == a || null == b) {
            return false;
        }
        if (a.code !== b.code) {
            return false;
        }
        if (!ProcessingRun.equals(a.run, b.run)) {
            return false;
        }
        return Timestamp.equals(a.timestamp, b.timestamp);
    }
};
__decorate([
    JsonProperty("code", String, false),
    __metadata("design:type", String)
], ProcessingEvent.prototype, "code", void 0);
__decorate([
    JsonProperty("Timestamp", Timestamp, false),
    __metadata("design:type", Timestamp)
], ProcessingEvent.prototype, "timestamp", void 0);
__decorate([
    JsonProperty("Run", ProcessingRun, true),
    __metadata("design:type", ProcessingRun)
], ProcessingEvent.prototype, "run", void 0);
ProcessingEvent = __decorate([
    JsonObject("ProcessingEvent")
], ProcessingEvent);
export { ProcessingEvent };
